import { AxiosError } from 'axios';
import { GenericError } from '@/models/generic-error';
import { useMutation } from '@tanstack/react-query';
import { fetchRefresh } from './service';
import { AuthService } from '@/services/AuthService';
import { RefreshAuthorizationOutputDto } from '@/services/dto/user-sessions/refresh-authorization-output.dto';
import { ErrorService } from '@starsoft/common/services';

export function useRefresh() {
  function onSuccess(data: RefreshAuthorizationOutputDto) {
    AuthService.setToken(data.accessToken);
    AuthService.setRefreshToken(data.refreshToken);
  }

  function onError(error: AxiosError<GenericError>) {
    ErrorService.onError(error);
    AuthService.logOut();
  }

  const { mutate, isPending, error, mutateAsync } = useMutation({
    onError,
    onSuccess,
    mutationFn: fetchRefresh,
  });

  return {
    refreshTokens: mutate,
    refreshTokensAsync: mutateAsync,
    isPending,
    error,
  };
}
